<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <PottingForm :station-id="stationId" :table-url="tableUrl"></PottingForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import PottingForm from "@/components/potting/PottingForm.vue";

const stationId = 40;
const viewName = "Potting";
const tableUrl = `/Material/GetLastPotting?num=6`;

onMounted(() => {
  document.title = viewName;
});
</script>
